import {
  Text
} from "@chakra-ui/react";
import Lang from "../../Lang";

export default function SectionHeading({ title, align }) {
  return (
    <Text
      as={"h2"}
      px={{ base: 4, md: 6 }}
      fontSize={{ base: "3em", md: "4em", lg: "5em", xl: "6em" }}
      color={"#4aeade"}
      className="barlow-black"
      align={align}
    >
      <Lang text={title} />
    </Text>
  );
}